<template>
  <div class="d-flex flex-column add-goal-actions">
    <gradient-button @click="goToNewGoal">
      Add a new goal
    </gradient-button>
    <gradient-button @click="openTemplateModal">
      {{ isAIFeatureEnabled ? 'Create goals with North AI' : 'Create goals with templates' }}
    </gradient-button>
    <templates-modal
      :org-id="orgId"
      v-model="templateGoalsModalShown"
      @select="onTemplateSelection"
    />
  </div>
</template>

<script>
import { trackAnalyticsEvent } from '@/analytics'
import GradientButton from '@/components/buttons/GradientButton.vue'
import TemplatesModal from '@/components/templates/TemplatesModal.vue'
import { EVENT_ACTION, EVENT_CATEGORY } from '@/constants/analytics'
import { featureFlags } from '@/constants/featureFlags'
import { TEMPLATE_TYPE } from '@/constants/goal'
import { ROUTE_NAMES } from '@/constants/routes'
import FeaturesMixin from '@/mixins/FeaturesMixin'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getNewGoalPageRouteConfig } from '@/utils/navigationConfigs'
import goToGoalCreationFromTemplate from '@/utils/templates/goToGoalCreationFromTemplate'

/**
 * This provides options to create goal
 *  - create a new goal
 *  - create goal via AI
 */
export default {
  name: 'AddGoalActions',
  props: ['orgId', 'teamId', 'expandGoalOnCreationPage'],
  mixins: [FeaturesMixin],
  components: { GradientButton, TemplatesModal },
  data() {
    return {
      ROUTE_NAMES,
      TEMPLATE_TYPE,
      newGoalLocation: getNewGoalPageRouteConfig({
        orgId: this.orgId,
        query: {
          expanded: !!this.expandGoalOnCreationPage,
          teamId: this.teamId
        }
      }),
      templateGoalsModalShown: false,
      isAIFeatureEnabled: this.getFeatureFlagValue(this.orgId, featureFlags.ALLOW_AI)
    }
  },
  computed: {},
  methods: {
    openTemplateModal() {
      trackAnalyticsEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.NEW_GOAL_AI_CLICKED)
      this.templateGoalsModalShown = true
    },
    onTemplateSelection(goal) {
      goToGoalCreationFromTemplate.call(this, this.orgId, this.teamId, goal)
    },
    goToNewGoal(event) {
      trackAnalyticsEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.NEW_GOAL_CLICKED)
      handleClickNavigation.call(this, event, this.newGoalLocation)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.new-goal-button {
  padding-top: 7px;
  padding-bottom: 7px;
}
.add-goal-text {
  line-height: 1.5;
}
.add-goal-actions {
  width: 275px;
  margin: 0 auto;
  gap: 16px;
}
</style>
